module.exports = __webpack_public_path__ + "media/images/procedure_managements/how_to_create/img_mobile_2-f734ba3fdb0d9438ada3ef71b627bbd3.png";